import { lazy } from "react";

export const FormPageLazy = lazy(() => import("./form-page/FormPage"));
export const MainPageLazy = lazy(() => import("./main-page/MainPage"));